module.exports = __webpack_public_path__ + "img/Capsule.a0a5d249.png";